import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const noteDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/notes/$noteId",
  component: lazyRouteComponent(() => import("./note-detail.page.js"), "NoteDetailPage"),
});
